import heading from "./heading";

export default function about() {
  const target = document.querySelector(".is-about");

  if (!target) return;

  heading();
}
